import React from 'react';
import { InfoIcon } from 'lucide-react';
export function LeagueCosts() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2634">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2635">
        <div className="mb-12" data-id="element-2636">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2637">
            League Costs
          </h2>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2638">
            {/* First time shooter banner */}
            <div className="bg-[#f0f7f3] p-4 border-b border-[#ede9e0] flex items-center gap-3" data-id="element-2639">
              <InfoIcon size={20} style={{
              color: '#2d5a3d'
            }} className="flex-shrink-0" data-id="element-2640" />
              <p className="text-base font-medium" style={{
              color: '#1e3d2f'
            }} data-id="element-2641">
                <strong data-id="element-2642">1st Time PPC Shooter (First Year):</strong> $20 Fall
                League, $20 Winter League
              </p>
            </div>

            <div className="overflow-x-auto" data-id="element-2643">
              <table className="w-full text-left border-collapse" data-id="element-2644">
                <thead data-id="element-2645">
                  <tr style={{
                  backgroundColor: '#1e3d2f'
                }} data-id="element-2646">
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#ffffff',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-2647">
                      League Type
                    </th>
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#c8a84b',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-2648">
                      Club Members
                    </th>
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#ffffff',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-2649">
                      Non-Members
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-2650">
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-2651">
                    <td className="p-4 font-medium text-gray-800" data-id="element-2652">
                      Combat Fall League
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-2653">$45</td>
                    <td className="p-4 font-medium text-gray-600" data-id="element-2654">$60</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-2655">
                    <td className="p-4 font-medium text-gray-800" data-id="element-2656">
                      Combat Winter League
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-2657">$45</td>
                    <td className="p-4 font-medium text-gray-600" data-id="element-2658">$60</td>
                  </tr>
                  <tr data-id="element-2659">
                    <td colSpan={3} className="p-4 text-sm text-gray-500 bg-gray-50 italic" data-id="element-2660">
                      * Add $15 for Service discipline for Club Members, Add $20
                      for Service discipline for Non-Members.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>;
}